import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { COMPANY_INFO } from '../data/siteData';

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet"
        description="Du har ikke adgang til denne side på Hærvejens Træpleje."
      />

      <section className="py-20 sm:py-28 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-20 h-20 bg-[#fef2f2] text-[#dc2626] rounded-full flex items-center justify-center mx-auto mb-6 text-3xl">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <span className="text-xs font-bold text-[#dc2626] bg-[#fef2f2] px-3.5 py-1.5 rounded-full inline-block mb-3">
          Fejl 403
        </span>

        <h1 className="text-3xl sm:text-5xl font-bold text-[#102419] mb-4">
          Adgang nægtet
        </h1>

        <p className="text-base sm:text-lg text-[#3d5044] mb-8 max-w-xl mx-auto">
          Du har ikke tilladelse eller adgang til den forespurgte ressource. Benyt venligst en af mulighederne herunder:
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 max-w-md sm:max-w-none mx-auto">
          <Link
            to="/"
            className="px-6 py-3.5 rounded-xl bg-[#1b4332] text-white font-semibold text-sm hover:bg-[#143627] transition-colors text-center"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/services"
            className="px-6 py-3.5 rounded-xl border border-[#2d6a4f] text-[#1b4332] font-semibold text-sm hover:bg-[#f2f7f4] transition-colors text-center"
          >
            Se ydelser
          </Link>
          <Link
            to="/kontakt"
            className="px-6 py-3.5 rounded-xl bg-[#f2f7f4] text-[#1b4332] font-semibold text-sm hover:bg-[#e4eee8] transition-colors text-center"
          >
            Kontakt Hærvejens Træpleje
          </Link>
        </div>

        <div className="mt-10 text-xs text-[#6e8074]">
          <p>
            Har du spørgsmål? Ring direkte til os på{' '}
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="underline font-bold text-[#1b4332] whitespace-nowrap">
              {COMPANY_INFO.phone}
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
